// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__2pEdb","header":"MessagesList_header__1uZ4W","chat":"MessagesList_chat__3HvA1"};